import { PixLogo, CreditCard, Money } from "@phosphor-icons/react";
import { twMerge } from "tailwind-merge";
import { Badge } from "../../../../../../components/ui/Badge";

export function TransactionBadgeMethod({ method, transactionId }) {
  let methodIcon = Money
  if (method.code === 'pix') methodIcon = PixLogo
  if (method.code === 'credit_card') methodIcon = CreditCard

  return (
    <Badge.Root
      name={transactionId}
      title={method.text}
      zIndex={111}
      style={{ background: method.color }}
      className={twMerge("mx-auto border [&>*]:!text-white [&>*]:!font-semibold")}>
      <Badge.Icon icon={methodIcon} className="w-6 h-6" />
    </Badge.Root>
  )
}
